<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/role' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>载体库</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="0">
            <el-col :span="24">
                <el-form :inline="true" :model="carrier" class="demo-form-inline" size="mini" @submit.native.prevent>
                    <el-form-item label="载体名称">
                        <el-input v-model="carrier.condition.carrierName" placeholder="载体名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="queryCarrier" @keyup.enter.native="enterQuery">查询</el-button>
                        <el-button type="primary" @click="toAddCarrier">新增</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                :data="carriers"
                :height="tableHeight"
                size="mini"
                border
                ref="tb"
                style="width: 100%">
                    <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                    <el-table-column fixed prop="carrierName" label="载体名称" width="200"></el-table-column>
                    <el-table-column prop="resistance" label="抗性" width="200"></el-table-column>
                    <el-table-column prop="bacterialStrain" label="菌株" width="200"></el-table-column>
                    <el-table-column prop="carrierUrl" label="载体详情链接" width="200"></el-table-column>
                    <el-table-column prop="detectionPrimer" label="检测引物" width="200"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button @click="toUpdate(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        <el-drawer
        :title="title"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        size="50%">
            <el-form :model="addCarrier" label-width="150px" ref="addForm" size="mini" @submit.native.prevent >
                <el-form-item label="载体名称" :prop="addCarrier.carrierName" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-input v-model="addCarrier.carrierName" ></el-input>
                </el-form-item>
                <el-form-item label="抗性" :prop="addCarrier.resistance" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-input v-model="addCarrier.resistance" ></el-input>
                </el-form-item>
                <el-form-item label="菌株" :prop="addCarrier.bacterialStrain" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-input v-model="addCarrier.bacterialStrain" ></el-input>
                </el-form-item>
                <el-form-item label="载体详情链接" :prop="addCarrier.carrierUrl" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-input v-model="addCarrier.carrierUrl" ></el-input>
                </el-form-item>
                <el-form-item label="检测引物" :prop="addCarrier.detectionPrimer">
                    <el-input v-model="addCarrier.detectionPrimer" ></el-input>
                </el-form-item>
                <div>
                    <el-divider content-position="center">上游酶切位点</el-divider>
                    <div v-for="(item, i) in addCarrier.upCleavageSiteList" :key="'upCleavageSite'+i">
                        <el-form-item :label="'酶切位点名称'+(i+1)" :prop="'upCleavageSiteList.'+i+'.cleavageSiteName'" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                            <el-input v-model="item.cleavageSiteName" style="width: 80%;"></el-input>
                            <el-button type="primary" @click="addItem()"> + </el-button>
                            <el-button type="warning" @click="deleteItem(i)"> – </el-button>
                        </el-form-item>
                    </div>
                    <el-divider content-position="center">下游酶切位点</el-divider>
                    <div v-for="(item, j) in addCarrier.downCleavageSiteList" :key="'downCleavageSite'+j">
                        <el-form-item :label="'酶切位点名称'+(j+1)" :prop="'downCleavageSiteList.'+j+'.cleavageSiteName'" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                            <el-input v-model="item.cleavageSiteName" style="width: 80%;"></el-input>
                            <el-button type="primary" @click="addDownItem()"> + </el-button>
                            <el-button type="warning" @click="deleteDownItem(j)"> – </el-button>
                        </el-form-item>
                    </div>
                </div>
                <el-row class="row-button">
                    <el-button size="mini"  type="primary" @click="submitCarrier('addForm')">提交</el-button>
                </el-row>
            </el-form>
        </el-drawer>
    </div>
    
</template>

<script>

    export default {
        name:'Carrier',
        data() {
            return {
                carrier: {
                    condition:{
                    },
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                carriers: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                tableHeight: "",//表格高度
                tableHeight1: "",//表格高度
                tableHeight2: "",//表格高度
                dialogFormVisible: false,
                addCarrier:{
                    carrierName:"",
                    resistance:"",
                    bacterialStrain:"",
                    upCleavageSiteList:[{cleavageSiteName : ""}],  //接收每个input框的值
                    downCleavageSiteList:[{cleavageSiteName : ""}]  //接收每个input框的值
                },
                updateDialog: false,
                updateCarrier: {
                    carrierName:"",
                    resistance:"",
                    bacterialStrain:"",
                    upCleavageSiteList:[{cleavageSiteName : ""}],  //接收每个input框的值
                    downCleavageSiteList:[{cleavageSiteName : ""}]  //接收每个input框的值
                },
                selectedCarrier: {},
                connectUpDialog: false,
                connectDownDialog: false,
                upCleavageSites: [],
                downCleavageSites: [],
                cleavageSiteData:[],
                connectedCleavageSiteUp:[],
                connectedCleavageSiteDown:[],
                defaultChecked: [],
                title:"",
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryCarrier();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryCarrier();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryCarrier();
                })
                .catch(() => {});
            },
            queryCarrier() {
                this.carrier.pageNum = this.currentPage;
                this.carrier.pageSize = this.pageSize;
                this.$axios.post("/carrierLibrary/find",this.carrier).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.carriers = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            formatStatus(row) {
                return row.roleStatus == "NORMAL" ? "正常": row.percentageStatus == "FROZEN" ? "冻结" : "已删除";
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
                this.tableHeight1 = this.tableHeight/2;
                this.tableHeight2 = this.tableHeight/2 - 10;
            },
            toAddCarrier() {
                this.drawer = true;
                this.title = '新增载体';
                // this.$set(this.addCarrier, "id", "");
                // this.$set(this.addCarrier, "carrierName", "");
                // this.$set(this.addCarrier, "resistance", "");
                // this.$set(this.addCarrier, "bacterialStrain", "");
                // this.$set(this.addCarrier, "carrierUrl", "");
                // this.$set(this.addCarrier, "detectionPrimer", "");
                // while(this.addCarrier.upCleavageSiteList.length > 0) {
                //     this.addCarrier.upCleavageSiteList.pop();
                // }
                // this.addCarrier.upCleavageSiteList.push({
                //     cleavageSiteName: "",
                // });

                // while(this.addCarrier.downCleavageSiteList.length > 0) {
                //     this.addCarrier.downCleavageSiteList.pop();
                // }
                // this.addCarrier.downCleavageSiteList.push({
                //     cleavageSiteName: "",
                // });
                this.addCarrier = {
                    carrierName:"",
                    resistance:"",
                    bacterialStrain:"",
                    upCleavageSiteList:[{cleavageSiteName : ""}],  //接收每个input框的值
                    downCleavageSiteList:[{cleavageSiteName : ""}]  //接收每个input框的值
                };
            },
            addItem() {
                this.addCarrier.upCleavageSiteList.push({
                    cleavageSiteName: "",
                });
            },
            deleteItem(i){
                if (this.addCarrier.upCleavageSiteList.length <= 1) {
                    return false;
                }
                this.addCarrier.upCleavageSiteList.splice(i, 1);
            },
            addDownItem() {
                this.addCarrier.downCleavageSiteList.push({
                    cleavageSiteName: "",
                });
            },
            deleteDownItem(i){
                if (this.addCarrier.downCleavageSiteList.length <= 1) {
                    return false;
                }
                this.addCarrier.downCleavageSiteList.splice(i, 1);
            },
            submitCarrier(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/carrierLibrary/batchSave",this.addCarrier).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message.info(res.data.message);
                                this.drawer = false;
                                this.queryCarrier();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                } else {
                    return false;
                }
                });
            },
            toUpdate(row) {
                this.drawer = true;
                this.title = '修改载体';
                var updateParam = {id:row.id}
                this.$axios.post("/carrierLibrary/findById",updateParam).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.addCarrier = res.data.result;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            del(row) {
                this.$confirm('您确认删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post("/carrierLibrary/delete",row).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.queryCarrier();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            toConnectUp() {
                if(!this.selectedCarrier.id) {
                    this.$message.error("请选择一条载体！");
                }else {
                    this.connectUpDialog = true;
                    if(this.connectedCleavageSiteUp.length > 0) {
                        let newArr = this.connectedCleavageSiteUp.map((item) => {
                            return item.id;
                        })
                        this.upCleavageSites = newArr;
                    } else {
                        this.upCleavageSites = [];
                    }
                }
            },
            queryCleavageSiteData() {
                this.$axios.post("/cleavageSite/findAll").then(
                    res=>{
                        if(res.data.status === "success"){
                            this.cleavageSiteData = res.data.result
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            subConnect(relType) {
                let cleavageSiteIds = [];
                if(relType === 'UP') {
                    cleavageSiteIds = this.upCleavageSites
                }else {
                    cleavageSiteIds = this.downCleavageSites;
                }
                var save = {
                    "carrierId": this.selectedCarrier.id,
                    "relType": relType,
                    "cleavageSiteIds": cleavageSiteIds
                }

                this.$axios.post("/cleavageSite/saveRel", save).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message.info("关联成功！");
                            if(relType === 'UP') {
                                this.flushUp();
                                this.connectUpDialog = false;
                            }else {
                                this.flushDown();
                                this.connectDownDialog = false;
                            }
                            
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            flushUp() {
                if(this.selectedCarrier.id) {
                    var upCondition = {
                        "carrierId": this.selectedCarrier.id,
                        "relType": "UP"
                    }
                    this.$axios.post("/cleavageSite/findByRelType",upCondition).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.connectedCleavageSiteUp = res.data.result;
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                }
            },
            flushDown() {
                if(this.selectedCarrier.id) {
                    var upCondition = {
                        "carrierId": this.selectedCarrier.id,
                        "relType": "DOWN"
                    }
                    this.$axios.post("/cleavageSite/findByRelType",upCondition).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.connectedCleavageSiteDown = res.data.result;
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                }
            },
            toConnectDown() {
                if(!this.selectedCarrier.id) {
                    this.$message.error("请选择一条载体！");
                }else {
                    this.connectDownDialog = true;
                    if(this.connectedCleavageSiteDown.length > 0) {
                        let newArr = this.connectedCleavageSiteDown.map((item) => {
                            return item.id;
                        })
                        this.downCleavageSites = newArr;
                    } else {
                        this.downCleavageSites = [];
                    }
                }
            },
            enterQuery(){
                document.onkeydown =(e) => {
                    e = window.event || e;
                    if(this.$route.path=='/home/carrier'&&(e.code=='Enter'||e.code=='enter')){
                        //调用查询方法
                        this.queryCarrier();
                        return;
                    }
                }
            },
        },
        mounted() {
            this.queryCarrier();
            this.queryCleavageSiteData();
        },
        created() {
            this.getTableHeight();
            this.enterQuery();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

   .connect-btn {
        display: flex;
        justify-content: right;
    }
    .row-button {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
   }

   .row-button >.el-button {
        margin-top: 10px;
        margin-right: 10px;
   }
</style>
